// Script Sconti Cart Label - Solo Carrello
// Luca Siviero

document.addEventListener("DOMContentLoaded", () => {
    let cartQty = 0;

    // 1. Tabella Sconti
    function getDiscount(qty) {
        if (qty >= 50) return 50;
        if (qty >= 35) return 40;
        if (qty >= 20) return 30;
        if (qty >= 10) return 25;
        if (qty >= 5) return 20;
        if (qty >= 3) return 15;
        if (qty >= 2) return 10;
        return 0;
    }

    // 2. Funzione che inietta fisicamente il badge nel DOM
    function injectBadges() {
        // Cerchiamo tutte le card prodotto nel carrello (mobile e desktop)
        const items = document.querySelectorAll('.line-item');
        
        items.forEach((itemEl) => {
            // Pulizia badge vecchi per evitare duplicati al cambio quantità
            itemEl.querySelectorAll('.custom-discount-badge').forEach(b => b.remove());

            // Identifichiamo se è un prodotto personalizzato (dal titolo o dall'URL)
            const titleLink = itemEl.querySelector('a[href*="/products/"]');
            if (!titleLink) return;

            const isEligible = titleLink.innerText.toLowerCase().includes('personalizzato') || 
                               titleLink.href.includes('personalizza');

            if (isEligible) {
                const discount = getDiscount(cartQty);
                if (discount > 0) {
                    // Puntiamo al prezzo finale (quello non barrato)
                    const priceTarget = itemEl.querySelector('.order-discount[data-cart-item-final-price]');
                    if (priceTarget) {
                        const badge = document.createElement("span");
                        badge.className = "custom-discount-badge";
                        badge.style.cssText = "font-weight:bold; margin-left:5px; font-size:0.9em; display:inline-block;";
                        badge.textContent = `(-${discount}%)`;
                        priceTarget.appendChild(badge);
                    }
                }
            }
        });
    }

    function updateCustomMessage(cartQty) {
        const wrapper = document.querySelector('.js-cart-page-contents .shipping-msg-wrapper #js-cumulative-discount-wrapper');
        if (!wrapper) return;

        if (cartQty === 0) {
            wrapper.innerHTML = '';
            return;
        }

        let next_qty = 0;
        let next_discount = 0;

        if (cartQty < 2) {
            next_qty = 2 - cartQty;
            next_discount = 10;
        } else if (cartQty < 3) {
            next_qty = 3 - cartQty;
            next_discount = 15;
        } else if (cartQty < 5) {
            next_qty = 5 - cartQty;
            next_discount = 20;
        } else if (cartQty < 10) {
            next_qty = 10 - cartQty;
            next_discount = 25;
        } else if (cartQty < 20) {
            next_qty = 20 - cartQty;
            next_discount = 30;
        } else if (cartQty < 35) {
            next_qty = 35 - cartQty;
            next_discount = 40;
        } else if (cartQty < 50) {
            next_qty = 50 - cartQty;
            next_discount = 50;
        }

        let message = "";
        if (next_qty > 0) {
            const mancaStr = next_qty === 1 ? "manca" : "mancano";
            const artStr = next_qty === 1 ? "articolo" : "articoli";
            message = `Sconto articoli personalizzati: ti ${mancaStr} <strong>${next_qty}</strong> ${artStr} per il <strong>-${next_discount}%</strong>`;
        } else {
            message = `🎉 Hai raggiunto lo sconto massimo del <strong>-50%</strong>!`;
        }

        wrapper.innerHTML = `
            <div class="custom-cumulative-discount-msg">
                ${message}
            </div>
        `;
    }

    // semaforo
    let isWorking = false;
    // 3. Funzione che interroga Shopify per sapere quanti pezzi ci sono
    async function syncCart() {
        if (isWorking) return; // Se sto già lavorando, non fare nulla
        isWorking = true;

        try {
            const res = await fetch('/cart.js');
            const cart = await res.json();
            
            // Sommiamo solo i pezzi dei prodotti personalizzati
            cartQty = cart.items.reduce((total, item) => {
                const eligible = item.vendor === "INDIANACAPSpersonalizzato" || 
                                 item.url.includes('/personalizza/') || 
                                 item.title.toLowerCase().includes('personalizzat')
                return eligible ? total + item.quantity : total;
            }, 0);

            updateCustomMessage(cartQty);

            // Disconnessione temporanea per evitare re-trigger su aggiunta badge
            observer.disconnect();

            // Una volta aggiornato il totale, aggiorniamo i badge
            injectBadges();

            // Riconnettiamo dopo l'iniezione
            startObserver(); 
        } catch (e) { 
            console.error("Errore fetch carrello", e); 
        } finally {
            isWorking = false;
        }
    }

    // 4. MutationObserver: serve per intercettare l'apertura del drawer o aggiornamenti AJAX
    const observer = new MutationObserver((mutations) => {
        // Controlliamo che non sia un badge appena aggiunto da questo script
        const isOurChange = Array.from(mutations).some(m => 
            Array.from(m.addedNodes).some(n => n.classList?.contains('custom-discount-badge'))
        );
        if (isOurChange) return;

        syncCart();
    });

    // Iniziamo a osservare tutto il body per i cambiamenti del DOM
    observer.observe(document.body, { childList: true, subtree: true });

    // 5. Intercettiamo le chiamate fetch per aggiornare quando l'utente cambia quantità
    const originalFetch = window.fetch;
    window.fetch = function() {
        return originalFetch.apply(this, arguments).then(async (response) => {
            if (response.url.includes('/cart/')) {
                // Aspettiamo un attimo che il tema finisca di renderizzare
                setTimeout(syncCart, 600);
            }
            return response;
        });
    };

    // Esecuzione immediata al caricamento
    startObserver();
    syncCart();
});